module.exports = __webpack_public_path__ + "static/sca1-c5ca4dbbe46013ef518d26103db5907b.png";